import { useUrlDataContext } from '../lib/UrlDataContext';
import { IoArrowForwardSharp } from 'react-icons/io5';
import './CurrentUrlReservedWarning.scss';

const MESSAGES = {
  matched: 'This URL has already been matched to a product',
  dismissed: 'This URL has been dismissed',
  reserved: 'This URL is being worked on by another matcher',
  expired: 'Your reservation has expired',
  error: 'Failed to reserve URL. Please try again.'
};

export const CurrentUrlReservedWarning = () => {
  const { reservationFailed, reservationFailReason, currentUrlData, removeUrlData } = useUrlDataContext();

  const handleSkip = () => {
    removeUrlData(currentUrlData.hashedUrlStem);
  };

  if (!reservationFailed) {
    return null;
  }

  const message = MESSAGES[reservationFailReason] || MESSAGES.reserved;

  return (
    <div className='current-url-reserved-warning'>
      {message}
      <button onClick={handleSkip}>
        Go to next URL <IoArrowForwardSharp size={16} />
      </button>
    </div>
  );
};
